// extracted by mini-css-extract-plugin
module.exports = {"logo":"a10a3f92e9--logo--aLEDl","img":"a10a3f92e9--img--nu9LM","title":"a10a3f92e9--title--zp4nZ"};